import { useMutation, useQueryClient } from "@tanstack/vue-query";
import baseAPI from "@/api/base";
import { SMSConversation } from "./useContactSMSConversations";

interface CreateSMSConversationPayload {
  contactId: string;
  phoneNumberId: string;
  contactPhoneNumber: string;
  contactPhoneId?: string;
}

export function useCreateSMSConversation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateSMSConversationPayload): Promise<SMSConversation> => {
      const response = await baseAPI.post("/twilio/sms/conversations", payload);
      return response.data.data;
    },
    onSuccess: (data) => {
      // Invalidate conversations list for this contact
      queryClient.invalidateQueries({
        queryKey: ["sms-conversations", data.contactId],
      });
    },
  });
}
